const getDomainNameFromUrl = (link: string) =>
  new URL(link).host.replace('www.', '');

export default getDomainNameFromUrl;
